exports.addUserApiMethod = "POST";
exports.addUserApiEndPoint = "";
exports.token="";
exports.placeHolderEmail = "Email address";

exports.TOKEN = "token"
exports.PROTECTED_ROUTES = ["settings2", "myorders", "chat", "orderreview"]
exports.LOGIN_PAGE_ROUTE = "/EmailAccountLoginBlock"
exports.LOGIN_PATH = "EmailAccountLoginBlock"
exports.USER_SLUG_SALT = 'bharat-stage-user-slug-salt';
exports.noResultsFoundText = "No results found"
exports.emptyArtistsMessage = `No trending artists at the moment.\nStay tuned for updates!`